import {Injectable, OnDestroy, OnInit} from '@angular/core';
import {BehaviorSubject, catchError, combineLatestWith, Observable, ReplaySubject, Subscription, throttleTime} from 'rxjs';
import {AppConfig} from "../../app.config";
import {AuthenticationService} from "../authentication.service";
import { NotificationService } from '../notification.service';
import { ProjectService } from '../project.service';
import { SummaryI } from './summary';

@Injectable()
export class BadgeService implements OnInit, OnDestroy {

  private summarySubject: BehaviorSubject<any> = new BehaviorSubject<SummaryI>(null);
  public summary$ = this.summarySubject.asObservable();
  private summarySubscription: Subscription;

  constructor(
    private authService: AuthenticationService,
    private notificationService: NotificationService,
    private projectService: ProjectService
  ) {

    this.summarySubscription = notificationService.newVisitor$.
      pipe( 
        combineLatestWith( this.projectService.getSelectedProjectId() ),
        throttleTime(5000, null, { trailing: true })
      )
      .subscribe(
        ([event,projectId]) => {
          
          if ( projectId == null ) {
            return;
          }

          this.fetchData( projectId ).subscribe({
            next: (data: SummaryI) => {
              this.summarySubject.next( data );
            }
          })
        }

    );
  }

  ngOnInit(): void {
  }

  private fetchData( projectId ) {
    const antiCache = '&ac=' + new Date().getTime()
    return this.authService.get( AppConfig.BASE_URL + '/visitor2/summary/?projectId=' + projectId + 
      antiCache + '&tz_shift=' + (-this.authService.tzOffset) );
  }

  public getSummary(): Observable<SummaryI> {
    return this.summary$;
  }

  ngOnDestroy(): void {
    if ( this.summarySubscription ) {
      this.summarySubscription.unsubscribe();
    }
  }

}

